import React from 'react';
import { useObservableState } from 'observable-hooks';
import { useHeyYabbleCountStepBLoC } from '../../HeyYabbleCountStep.bloc';
import { HeyYabbleCountStepTableHeader } from './components/HeyYabbleCountStepTableHeader/HeyYabbleCountStepTableHeader';
import { HeyYabbleCountStepTableRow } from './components/HeyYabbleCountStepTableRow/HeyYabbleCountStepTableRow';
import { HeyYabbleCountStepTableStyle as S } from './HeyYabbleCountStepTable.style';
import { HStack, VStack } from 'components/layouts/primitives/Stack/Stack';
import { PButton } from 'components/prime/PButton/PButton';
import { getUserStore } from 'stores/user.store';
import { PInputSwitch } from 'components/prime/PInputSwitch/PInputSwitch';

export const HeyYabbleCountStepTable: React.FC = () => {
  const {
    $selectedColumnsIds,
    $columns,
    $useLegacyCodeframes,
    handleUseLegacyCodeframes,
  } = useHeyYabbleCountStepBLoC();
  const selectedColumns = useObservableState($selectedColumnsIds, []);
  const columnsWithCostDetails = useObservableState($columns, []);
  const useLegacyCodeframes = useObservableState($useLegacyCodeframes);
  const user = useObservableState(getUserStore().$user);

  return (
    <VStack gap="gap4">
      <HStack gap="gap3" align="center" justify="flex-end">
        {!!user?.isYabbleOwner && (
          <PInputSwitch
            checked={useLegacyCodeframes}
            label="Legacy codeframes"
            onChange={(e) => handleUseLegacyCodeframes(!!e.target.value)}
          />
        )}
        <PButton
          label="Manage codeframes"
          severity="secondary"
          as="a"
          href="/settings/codeframes"
          target="_blank"
          rel="noopener noreferrer"
        />
      </HStack>
      <S.Container>
        <HeyYabbleCountStepTableHeader />
        {columnsWithCostDetails.map((column, i) => (
          <HeyYabbleCountStepTableRow key={i} {...{ column, selectedColumns }} />
        ))}
      </S.Container>
    </VStack>
  );
};
